import ACCOUNTING from './svg/accounting.svg';
import ADDED_FAVORITE from './svg/added_favorite.svg';
import ALERT from './svg/alert.svg';
import ARCHIVE_BOX from './svg/archive_box.svg';
import ARCHIVE from './svg/archive.svg';
import ARROW_ADD_LEFT from './svg/arrow_add_left.svg';
import ARROW_DOWN_REDESIGN from './svg/arrow_down_redesign.svg';
import ARROW_DOWN from './svg/arrow_down.svg';
import ARROW_LEFT from './svg/arrow_left.svg';
import ARROW_UP from './svg/arrow_up.svg';
import ATTACHED from './svg/attached.svg';
import BACK_ARROW_BLACK from './svg/back_arrow_black.svg';
import BACK_ARROW_WHITE from './svg/back_arrow_white.svg';
import BACK_ARROW from './svg/back_arrow.svg';
import BANK_CARD from './svg/bank_card.svg';
import BANKNOTE from './svg/banknote.svg';
import BELL from './svg/bell.svg';
import CALENDAR_REDESIGN from './svg/calendar_redesign.svg';
import CALENDAR from './svg/calendar.svg';
import CAMERA from './svg/camera.svg';
import CERTIFICATE from './svg/certificate.svg';
import CHECK_REDESIGN from './svg/check_redesign.svg';
import CHECK from './svg/check.svg';
import CHEVRON_DOWN from './svg/chevron_down.svg';
import CHILD from './svg/child.svg';
import CLOCK from './svg/clock.svg';
import COMMENT_NEW from './svg/comment_new.svg';
import COMMENT from './svg/comment.svg';
import COPY from './svg/copy.svg';
import CREDIT_CARD from './svg/credit_card.svg';
import CROSS_IN_CIRCLE from './svg/cross_in_circle.svg';
import CROSS from './svg/cross.svg';
import CUSTOMER from './svg/customer.svg';
import DANGER from './svg/danger.svg';
import DASHBOARDS from './svg/dashboards.svg';
import DISCOUNT from './svg/discount.svg';
import DISPLAY from './svg/display.svg';
import DOCUMENT from './svg/document.svg';
import DOWNLOAD_NEW from './svg/download_new.svg';
import DOWNLOAD from './svg/download.svg';
import EDIT from './svg/edit.svg';
import EDIT_PEN from './svg/edit_pen.svg';
import EMAIL from './svg/email.svg';
import ENTRY_TYPE from './svg/entry_type.svg';
import EYE from './svg/eye.svg';
import FAVORITE from './svg/favorite.svg';
import FEMALE from './svg/female.svg';
import FILLED_COMMENT from './svg/filled_comment.svg';
import FILTER_NEW from './svg/filter_new.svg';
import FILTER_REDESIGN from './svg/filter_redesign.svg';
import FILTER from './svg/filter.svg';
import FLAG from './svg/flag.svg';
import GOOGLE from './svg/google.svg';
import GROUPING from './svg/grouping.svg';
import HAMBURGER from './svg/hamburger.svg';
import HELPDESK from './svg/helpdesk.svg';
import HIDE from './svg/hide.svg';
import HISTORY from './svg/history.svg';
import INFO from './svg/info.svg';
import INSURANCE from './svg/insurance.svg';
import KEBAB from './svg/kebab.svg';
import LAB from './svg/lab.svg';
import LINK from './svg/link.svg';
import LOGO_SHORT from './svg/logo_short.svg';
import LOGO from './svg/logo.svg';
import MALE from './svg/male.svg';
import MEATBALL from './svg/meatball.svg';
import MICROPHONE from './svg/microphone.svg';
import NEW_SCHEDULE from './svg/new_schedule.svg';
import NEW_TAB from './svg/new_tab.svg';
import NOT_VALID from './svg/not_valid.svg';
import OK_CIRCLE from './svg/ok_circle.svg';
import OK_IN_MESSAGE from './svg/ok_in_message.svg';
import OK_SHIELD from './svg/ok_shield.svg';
import ON_HOLD from './svg/on_hold.svg';
import OPEN_ICON from './svg/open_icon.svg';
import OPEN_LINK from './svg/open_link.svg';
import ORGANIZATION from './svg/organization.svg';
import PAPER_PLANE from './svg/paper_plane.svg';
import PATIENT from './svg/patient.svg';
import PAUSE from './svg/pause.svg';
import PAYMENT from './svg/payment.svg';
import PEN_REDESIGN from './svg/pen_redesign.svg';
import PEN from './svg/pen.svg';
import PENCIL from './svg/pencil.svg';
import PERCENT_IN_CIRCLE from './svg/percent_in_circle.svg';
import PHONE from './svg/phone.svg';
import PILLS from './svg/pills.svg';
import PLAN from './svg/plan.svg';
import PLUS from './svg/plus.svg';
import PRICE_LIST from './svg/price_list.svg';
import PULSE from './svg/pulse.svg';
import READY_FOR_DESCRIBING from './svg/ready_for_describing.svg';
import RECORD from './svg/record.svg';
import REMOVE_REDESIGN from './svg/remove_redesign.svg';
import REMOVE from './svg/remove.svg';
import REPLAY_ARROW from './svg/replay_arrow.svg';
import REPLY from './svg/reply.svg';
import ROLL_BACK from './svg/roll_back.svg';
import SCHEDULE from './svg/schedule.svg';
import SEARCH_REDESIGN from './svg/search_redesign.svg';
import SEARCH from './svg/search.svg';
import SERVICE from './svg/service.svg';
import SETTING from './svg/setting.svg';
import SHIELD_LOCK from './svg/shield_lock.svg';
import SHOW from './svg/show.svg';
import SORTING_NEW_AZ from './svg/sorting_new_az.svg';
import SORTING_NEW_ZA from './svg/sorting_new_za.svg';
import SORTING from './svg/sorting.svg';
import STAR_FILLED from './svg/star_filled.svg';
import STAR from './svg/star.svg';
import STORE from './svg/store.svg';
import SUPPORT from './svg/support.svg';
import TABLE_FILTER from './svg/table_filter.svg';
import TEMPLATE from './svg/template.svg';
import TOOLTIP_BURGER from './svg/tooltip_burger.svg';
import TRASH_REDESIGN from './svg/trash_redesign.svg';
import TRASH from './svg/trash.svg';
import UN_ARCHIVE from './svg/un_archive.svg';
import UNDO from './svg/undo.svg';
import UNEVEN_ARROW from './svg/uneven_arrow.svg';
import USER from './svg/user.svg';
import VERSION from './svg/version.svg';
import WARNING from './svg/warning.svg';
import WINDOW_TEXT from './svg/window-text.svg';
import FAMILY from './svg/family.svg';
import LOCATION from './svg/location.svg';
import { ComponentType, SVGAttributes } from 'react';

enum IconType {
    WINDOW_TEXT = 'window-text',
    WARNING = 'warning',
    VERSION = 'version',
    USER = 'user',
    UNEVEN_ARROW = 'uneven_arrow',
    UNDO = 'undo',
    UN_ARCHIVE = 'un_archive',
    TRASH_REDESIGN = 'trash_redesign',
    TRASH = 'trash',
    TOOLTIP_BURGER = 'tooltip_burger',
    TEMPLATE = 'template',
    TABLE_FILTER = 'table_filter',
    SUPPORT = 'support',
    STORE = 'store',
    STAR_FILLED = 'star_filled',
    STAR = 'star',
    SORTING_NEW_ZA = 'sorting_new_za',
    SORTING_NEW_AZ = 'sorting_new_az',
    SORTING = 'sorting',
    SHOW = 'show',
    SHIELD_LOCK = 'shield_lock',
    SETTING = 'setting',
    SERVICE = 'service',
    SEARCH_REDESIGN = 'search_redesign',
    SEARCH = 'search',
    SCHEDULE = 'schedule',
    ROLL_BACK = 'roll_back',
    REPLY = 'reply',
    REPLAY_ARROW = 'replay_arrow',
    REMOVE_REDESIGN = 'remove_redesign',
    REMOVE = 'remove',
    RECORD = 'record',
    READY_FOR_DESCRIBING = 'ready_for_describing',
    PULSE = 'pulse',
    PRICE_LIST = 'price_list',
    PLUS = 'plus',
    PLAN = 'plan',
    PILLS = 'pills',
    PHONE = 'phone',
    PERCENT_IN_CIRCLE = 'percent_in_circle',
    PENCIL = 'pencil',
    PEN_REDESIGN = 'pen_redesign',
    PEN = 'pen',
    PAYMENT = 'payment',
    PAUSE = 'pause',
    PATIENT = 'patient',
    PAPER_PLANE = 'paper_plane',
    ORGANIZATION = 'organization',
    OPEN_LINK = 'open_link',
    OPEN_ICON = 'open_icon',
    ON_HOLD = 'on_hold',
    OK_SHIELD = 'ok_shield',
    OK_IN_MESSAGE = 'ok_in_message',
    OK_CIRCLE = 'ok_circle',
    NOT_VALID = 'not_valid',
    NEW_TAB = 'new_tab',
    NEW_SCHEDULE = 'new_schedule',
    MICROPHONE = 'microphone',
    MEATBALL = 'meatball',
    MALE = 'male',
    LOGO_SHORT = 'logo_short',
    LOGO = 'logo',
    LINK = 'link',
    LAB = 'lab',
    KEBAB = 'kebab',
    INSURANCE = 'insurance',
    INFO = 'info',
    HISTORY = 'history',
    HIDE = 'hide',
    HELPDESK = 'helpdesk',
    HAMBURGER = 'hamburger',
    GROUPING = 'grouping',
    GOOGLE = 'google',
    FLAG = 'flag',
    FILTER_REDESIGN = 'filter_redesign',
    FILTER_NEW = 'filter_new',
    FILTER = 'filter',
    FILLED_COMMENT = 'filled_comment',
    FEMALE = 'female',
    FAVORITE = 'favorite',
    FAMILY = 'family',
    EYE = 'eye',
    ENTRY_TYPE = 'entry_type',
    EMAIL = 'email',
    EDIT = 'edit',
    EDIT_PEN = 'edit_pen',
    DOWNLOAD_NEW = 'download_new',
    DOWNLOAD = 'download',
    DOCUMENT = 'document',
    DISPLAY = 'display',
    DISCOUNT = 'discount',
    DASHBOARDS = 'dashboards',
    DANGER = 'danger',
    CUSTOMER = 'customer',
    CROSS_IN_CIRCLE = 'cross_in_circle',
    CROSS = 'cross',
    CREDIT_CARD = 'credit_card',
    COPY = 'copy',
    COMMENT_NEW = 'comment_new',
    COMMENT = 'comment',
    CLOCK = 'clock',
    CHILD = 'child',
    CHEVRON_DOWN = 'chevron_down',
    CHECK_REDESIGN = 'check_redesign',
    CHECK = 'check',
    CERTIFICATE = 'certificate',
    CAMERA = 'camera',
    CALENDAR_REDESIGN = 'calendar_redesign',
    CALENDAR = 'calendar',
    BELL = 'bell',
    BANKNOTE = 'banknote',
    BANK_CARD = 'bank_card',
    BACK_ARROW_WHITE = 'back_arrow_white',
    BACK_ARROW_BLACK = 'back_arrow_black',
    BACK_ARROW = 'back_arrow',
    ATTACHED = 'attached',
    ARROW_UP = 'arrow_up',
    ARROW_LEFT = 'arrow_left',
    ARROW_DOWN_REDESIGN = 'arrow_down_redesign',
    ARROW_DOWN = 'arrow_down',
    ARROW_ADD_LEFT = 'arrow_add_left',
    ARCHIVE_BOX = 'archive_box',
    ARCHIVE = 'archive',
    ALERT = 'alert',
    ADDED_FAVORITE = 'added_favorite',
    ACCOUNTING = 'accounting',
    LOCATION = 'location',
}

const IconTypeToComponentMap: Record<IconType, ComponentType<SVGAttributes<SVGElement>>> = {
    [IconType.WINDOW_TEXT]: WINDOW_TEXT,
    [IconType.WARNING]: WARNING,
    [IconType.VERSION]: VERSION,
    [IconType.USER]: USER,
    [IconType.UNEVEN_ARROW]: UNEVEN_ARROW,
    [IconType.UNDO]: UNDO,
    [IconType.UN_ARCHIVE]: UN_ARCHIVE,
    [IconType.TRASH_REDESIGN]: TRASH_REDESIGN,
    [IconType.TRASH]: TRASH,
    [IconType.TOOLTIP_BURGER]: TOOLTIP_BURGER,
    [IconType.TEMPLATE]: TEMPLATE,
    [IconType.TABLE_FILTER]: TABLE_FILTER,
    [IconType.SUPPORT]: SUPPORT,
    [IconType.STORE]: STORE,
    [IconType.STAR_FILLED]: STAR_FILLED,
    [IconType.STAR]: STAR,
    [IconType.SORTING_NEW_ZA]: SORTING_NEW_ZA,
    [IconType.SORTING_NEW_AZ]: SORTING_NEW_AZ,
    [IconType.SORTING]: SORTING,
    [IconType.SHOW]: SHOW,
    [IconType.SHIELD_LOCK]: SHIELD_LOCK,
    [IconType.SETTING]: SETTING,
    [IconType.SERVICE]: SERVICE,
    [IconType.SEARCH_REDESIGN]: SEARCH_REDESIGN,
    [IconType.SEARCH]: SEARCH,
    [IconType.SCHEDULE]: SCHEDULE,
    [IconType.ROLL_BACK]: ROLL_BACK,
    [IconType.REPLY]: REPLY,
    [IconType.REPLAY_ARROW]: REPLAY_ARROW,
    [IconType.REMOVE_REDESIGN]: REMOVE_REDESIGN,
    [IconType.REMOVE]: REMOVE,
    [IconType.RECORD]: RECORD,
    [IconType.READY_FOR_DESCRIBING]: READY_FOR_DESCRIBING,
    [IconType.PULSE]: PULSE,
    [IconType.PRICE_LIST]: PRICE_LIST,
    [IconType.PLUS]: PLUS,
    [IconType.PLAN]: PLAN,
    [IconType.PILLS]: PILLS,
    [IconType.PHONE]: PHONE,
    [IconType.PERCENT_IN_CIRCLE]: PERCENT_IN_CIRCLE,
    [IconType.PENCIL]: PENCIL,
    [IconType.PEN_REDESIGN]: PEN_REDESIGN,
    [IconType.PEN]: PEN,
    [IconType.PAYMENT]: PAYMENT,
    [IconType.PAUSE]: PAUSE,
    [IconType.PATIENT]: PATIENT,
    [IconType.PAPER_PLANE]: PAPER_PLANE,
    [IconType.ORGANIZATION]: ORGANIZATION,
    [IconType.OPEN_LINK]: OPEN_LINK,
    [IconType.OPEN_ICON]: OPEN_ICON,
    [IconType.ON_HOLD]: ON_HOLD,
    [IconType.OK_SHIELD]: OK_SHIELD,
    [IconType.OK_IN_MESSAGE]: OK_IN_MESSAGE,
    [IconType.OK_CIRCLE]: OK_CIRCLE,
    [IconType.NOT_VALID]: NOT_VALID,
    [IconType.NEW_TAB]: NEW_TAB,
    [IconType.NEW_SCHEDULE]: NEW_SCHEDULE,
    [IconType.MICROPHONE]: MICROPHONE,
    [IconType.MEATBALL]: MEATBALL,
    [IconType.MALE]: MALE,
    [IconType.LOGO_SHORT]: LOGO_SHORT,
    [IconType.LOGO]: LOGO,
    [IconType.LINK]: LINK,
    [IconType.LAB]: LAB,
    [IconType.KEBAB]: KEBAB,
    [IconType.INSURANCE]: INSURANCE,
    [IconType.INFO]: INFO,
    [IconType.HISTORY]: HISTORY,
    [IconType.HIDE]: HIDE,
    [IconType.HELPDESK]: HELPDESK,
    [IconType.HAMBURGER]: HAMBURGER,
    [IconType.GROUPING]: GROUPING,
    [IconType.GOOGLE]: GOOGLE,
    [IconType.FLAG]: FLAG,
    [IconType.FILTER_REDESIGN]: FILTER_REDESIGN,
    [IconType.FILTER_NEW]: FILTER_NEW,
    [IconType.FILTER]: FILTER,
    [IconType.FILLED_COMMENT]: FILLED_COMMENT,
    [IconType.FEMALE]: FEMALE,
    [IconType.FAVORITE]: FAVORITE,
    [IconType.EYE]: EYE,
    [IconType.ENTRY_TYPE]: ENTRY_TYPE,
    [IconType.EMAIL]: EMAIL,
    [IconType.EDIT]: EDIT,
    [IconType.EDIT_PEN]: EDIT_PEN,
    [IconType.DOWNLOAD_NEW]: DOWNLOAD_NEW,
    [IconType.DOWNLOAD]: DOWNLOAD,
    [IconType.DOCUMENT]: DOCUMENT,
    [IconType.DISCOUNT]: DISCOUNT,
    [IconType.DASHBOARDS]: DASHBOARDS,
    [IconType.DANGER]: DANGER,
    [IconType.CUSTOMER]: CUSTOMER,
    [IconType.CROSS_IN_CIRCLE]: CROSS_IN_CIRCLE,
    [IconType.CROSS]: CROSS,
    [IconType.CREDIT_CARD]: CREDIT_CARD,
    [IconType.COPY]: COPY,
    [IconType.COMMENT_NEW]: COMMENT_NEW,
    [IconType.COMMENT]: COMMENT,
    [IconType.CLOCK]: CLOCK,
    [IconType.CHILD]: CHILD,
    [IconType.CHEVRON_DOWN]: CHEVRON_DOWN,
    [IconType.CHECK_REDESIGN]: CHECK_REDESIGN,
    [IconType.CHECK]: CHECK,
    [IconType.CERTIFICATE]: CERTIFICATE,
    [IconType.CAMERA]: CAMERA,
    [IconType.CALENDAR_REDESIGN]: CALENDAR_REDESIGN,
    [IconType.CALENDAR]: CALENDAR,
    [IconType.BELL]: BELL,
    [IconType.BANKNOTE]: BANKNOTE,
    [IconType.BANK_CARD]: BANK_CARD,
    [IconType.BACK_ARROW_WHITE]: BACK_ARROW_WHITE,
    [IconType.BACK_ARROW_BLACK]: BACK_ARROW_BLACK,
    [IconType.BACK_ARROW]: BACK_ARROW,
    [IconType.ATTACHED]: ATTACHED,
    [IconType.ARROW_UP]: ARROW_UP,
    [IconType.ARROW_LEFT]: ARROW_LEFT,
    [IconType.ARROW_DOWN_REDESIGN]: ARROW_DOWN_REDESIGN,
    [IconType.ARROW_DOWN]: ARROW_DOWN,
    [IconType.ARROW_ADD_LEFT]: ARROW_ADD_LEFT,
    [IconType.ARCHIVE_BOX]: ARCHIVE_BOX,
    [IconType.ARCHIVE]: ARCHIVE,
    [IconType.ALERT]: ALERT,
    [IconType.ADDED_FAVORITE]: ADDED_FAVORITE,
    [IconType.ACCOUNTING]: ACCOUNTING,
    [IconType.DISPLAY]: DISPLAY,
    [IconType.FAMILY]: FAMILY,
    [IconType.LOCATION]: LOCATION,
};

export { IconTypeToComponentMap, IconType };
